<template>
  <div>
    <v-btn outlined @click="dialog = true" class="d-flex align-center" :style="{ minWidth: '120px' }">
      <span
        v-if="color"
        :style="{
          display: 'inline-block',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          background: color,
          marginRight: '8px'
        }"
      ></span>
      <span v-else style="margin-right: 8px; color: #aaa;">Не выбран</span>
    </v-btn>

    <v-dialog v-model="dialog" max-width="320">
      <v-card>
        <!-- {{tempColor}} -->
        <v-card-title>Выберите цвет</v-card-title>
        <v-card-text>
          <v-color-picker v-model="tempColor" hide-inputs flat mode="hexa" />
          <div class="d-flex ml-4">
            Стандартные цвета:
            <div class="color-sample color-sample-red" @click="setStdColor('#E53E3E')" />
            <div class="color-sample color-sample-green" @click="setStdColor('#6FCF97')"/>
            <div class="color-sample color-sample-yellow" @click="setStdColor('#FC9A1A')"/>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Отмена</v-btn>
          <v-btn color="primary" text @click="selectColor">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ColorPickerButton',
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dialog: false,
      color: this.value,
      tempColor: this.value
    };
  },
  watch: {
    value(val) {
      this.color = val;
      this.tempColor = val;
    }
  },
  methods: {
    selectColor() {
      this.color = this.tempColor.hex ?? this.tempColor;
      this.$emit('input', this.color);
      this.dialog = false;
    },
    setStdColor(c) {
      if (this.tempColor.hex) {
        this.tempColor.hex = c;
      } else {
        this.tempColor = c;
      }
    }
  }
};
</script>

<style>
.color-sample {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  margin-left: 10px;
  cursor: pointer;
}
.color-sample-red {
  background: #E53E3E;
}
.color-sample-green {
  background: #6FCF97;
}
.color-sample-yellow {
  background: #FC9A1A;
}

</style>
